// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Fg_Y","emails":"CreateEditClinics_emails__2jW6H","emailTagLabel":"CreateEditClinics_emailTagLabel__1fs46"};